import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})

export class AdminComponent implements OnInit {

  @Input() violationsData: any;
  violationResults = [];
  roles = [];
  violationsForm: FormGroup;

  constructor() { }

  ngOnInit() {

    let results = [];
    this.violationsData.forEach(element => {
      let userName = element.userProfileId.get('firstName') + ' ' + element.userProfileId.get('lastName');
      let reporterName = element.reportingTo.get('firstName') + ' ' + element.reportingTo.get('lastName');
      let role = element.userProfileId.get('role').get('name');
      let location = element.userProfileId.get('location').get('name');
      let inTimeValue = element.violations.filter(a => a.type == 'In-Time')[0];
      inTimeValue = inTimeValue == undefined ? '' : inTimeValue;

      let incompleteHrsValue = element.violations.filter(a => a.type == 'Incompleted-Hours')[0];
      incompleteHrsValue = incompleteHrsValue == undefined ? '' : incompleteHrsValue;

      let breakHrsValue = element.violations.filter(a => a.type == 'Exceeded-Break-Hours')[0];
      breakHrsValue = breakHrsValue == undefined ? '' : breakHrsValue;

      results.push({
        userName, role,
        location: location,
        outTime: incompleteHrsValue.inCompletedHours,
        inTime: inTimeValue.inTime,
        id: element.objectId,
        status: element.status,
        startTime: element.startTime,
        date: element.violatedDate,
        breakHrs: breakHrsValue.exceededHours,
        isResolved: element.isResolved,
        inTimeReason: inTimeValue.reason == undefined ? '' : inTimeValue.reason,
        incompletedHrsReason: incompleteHrsValue.reason == undefined ? '' : incompleteHrsValue.reason,
        breakHrsReason: breakHrsValue.reason == undefined ? '' : breakHrsValue.reason,
        reporter: reporterName
      });
    });
    this.violationResults = results;

  }

}
